import { Configuration } from "src/app/constants/configuration";
import { Contratante, CorreosContratante } from "src/app/models/contratante.model";
import { QuattroB2C } from "src/app/models/quattroB2C.model";
import { RequestServices } from "src/app/services/request.service";
import { StorageService } from "src/app/services/storage.service";
import { Observable, Subject } from 'rxjs';

export class ClienteHelper {   
  private subject = new Subject<any>(); 
  constructor(private requestService: RequestServices, private storageService: StorageService, private quattroB2C: QuattroB2C, private contratante: Contratante) {}

  getCliente(): Observable<any> {
    try {
      this.requestService.getRequest({ projectName: new Configuration().API_CLIENTE, apiName: 'cliente/id', params: { "id": this.quattroB2C.contratante?.clienteIDEnc } }).subscribe(
        result => {
          if (result.error) {
            console.error(result.error);
            this.subject.next(false);
          } else {
            if (this.storageService.ifExist('quattroB2C')) {
              this.quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));                                
            } 
            let fecha =result.result.fecNacimiento.split(' ')[0]; 
            let anio = fecha.split('-')[0];
            let mes =  fecha.split('-')[1];
            let dia = fecha.split('-')[2];
            let fechaNac = dia+'/'+mes+'/'+anio;


            this.contratante.clienteIDEnc = result.result.clienteIDEnc;
            this.contratante.nombres = result.result.nombres;
            this.contratante.ap_pat = result.result.apPat;
            this.contratante.ap_mat = result.result.apMat;
            this.contratante.fec_nac = fechaNac;
            this.contratante.fec_nac_str = result.result.fecNacimiento;
            this.contratante.sexo = result.result.sexo;
            this.contratante.rfc = result.result.rfc;

            this.contratante.direccion.col = result.result.direcciones[0].colonia;
            this.contratante.direccion.calle = result.result.direcciones[0].calle;
            this.contratante.direccion.no_ext = result.result.direcciones[0].noExterno;
            this.contratante.direccion.no_int = result.result.direcciones[0].noInterno;
            this.contratante.direccion.cp = result.result.direcciones[0].cp;
            this.contratante.direccion.cpId = result.result.direcciones[0].cpID;
            this.contratante.direccion.delegacion_mcpio = result.result.direcciones[0].municipio;
            this.contratante.direccion.clienteId = result.result.direcciones[0].clienteID;
            this.contratante.direccion.direccionClienteId = result.result.direcciones[0].direccionClienteID;
            this.contratante.direccion.estado = result.result.direcciones[0].estadoID;
            this.contratante.direccion.c_mcpio = result.result.direcciones[0].mcpioID;
            this.contratante.direccion.direccionClienteIDEnc = result.result.direcciones[0].direccionClienteIDEnc;
            let listCorreosContratante: CorreosContratante[] = [];
            let correosContratante: CorreosContratante = new CorreosContratante();
            correosContratante.tipo = 1;
            if (result.result.correos?.length>0){              
                correosContratante.correo =  result.result.correos[0].correo;
                listCorreosContratante.push(correosContratante);            
                this.contratante.correos = listCorreosContratante;
            }
            this.quattroB2C.contratante = this.contratante;
            this.storageService.setItem('quattroB2C', JSON.stringify(this.quattroB2C));

            this.subject.next(true);               
          }
        }, error => {
          console.error(error.message);
          this.subject.next(false);
        }
      );

    } catch (error) {
      console.error("error", error);
      this.subject.next(false);
    }

    return this.subject.asObservable();
  }
}